import type { CompressionLevel, PdfClassification } from './lib'
import type { CompressionLandingSource } from './targetPreset'

export type CompressionSource = 'compress' | 'target-size-5mb'
export type CompressionFailureCategory =
  | 'invalid_input'
  | 'encrypted_input'
  | 'size_limit'
  | 'processing_failed'

type CompressionMode = 'noop' | 'wasm'
type CoverageBand = 'full' | 'partial' | 'limited'

export interface CompressionAnalyticsDetails {
  mode?: CompressionMode
  coverageBand?: CoverageBand
  targetMet?: boolean
  failureCategory?: CompressionFailureCategory
}

export function coverageBand(
  classification: Pick<PdfClassification, 'wasmCoverageRatio'>,
): CoverageBand {
  if (classification.wasmCoverageRatio >= 0.8) return 'full'
  if (classification.wasmCoverageRatio >= 0.5) return 'partial'
  return 'limited'
}

export function compressionAnalyticsParams(
  source: CompressionSource,
  landingSource: CompressionLandingSource,
  level: CompressionLevel,
  hasTarget: boolean,
  details: CompressionAnalyticsDetails = {},
): Record<string, unknown> {
  return {
    source,
    landing_source: landingSource,
    level,
    target_preset: hasTarget ? '5mb' : 'none',
    ...(details.mode ? { mode: details.mode } : {}),
    ...(details.coverageBand
      ? { coverage_band: details.coverageBand }
      : {}),
    ...(details.targetMet == null
      ? {}
      : { target_met: details.targetMet }),
    ...(details.failureCategory
      ? { failure_category: details.failureCategory }
      : {}),
  }
}
